// import sx from '@mui/system/sx';
import IAction from '../types/action';

export const taskOutcomes: { value: string; label: string }[] = [
  { label: 'Made contact', value: '1' },
  { label: 'Email sent', value: '2' },
  { label: 'Left voicemail', value: '3' },
  { label: 'Did not contact', value: '4' },
];

const actions: IAction[] = [
  {
    id: 1,
    name: 'Collect Information',
    dueDate: 'July 25, 2022',
    tasks: [
      { id: '1', name: 'Collect DMV info', assignee: 'Jereme Belle', canAutoComplete: true, status: 'NotStarted' },
      { id: '2', name: 'Collect Delivery info', assignee: 'Jereme Belle', status: 'NotStarted' },
      { id: '3', name: 'Collect Registration info', assignee: 'Jereme Belle', status: 'NotStarted' },
    ],
  },
  {
    id: 2,
    name: 'Reach out to customer to sign purchase agreement',
    dueDate: 'July 25, 2022',
    tasks: [
      {
        id: '1',
        name: 'Introduce customer to purchase agreement',
        assignee: 'Jereme Belle',
        canAutoComplete: true,
        status: 'NotStarted',
      },
      { id: '2', name: 'Empathize customer by resolving all queries', assignee: 'Jereme Belle', status: 'NotStarted' },
      { id: '3', name: 'Collect Registration info', assignee: 'Jereme Belle', status: 'NotStarted' },
    ],
  },
  {
    id: 3,
    name: 'Collect Information',
    dueDate: 'July 25, 2022',
    tasks: [
      { id: '1', name: 'Collect DMV info', assignee: 'Jereme Belle', canAutoComplete: true, status: 'Completed' },
      { id: '2', name: 'Collect Delivery info', assignee: 'Jereme Belle', status: 'Completed' },
      { id: '3', name: 'Collect Registration info', assignee: 'Jereme Belle', status: 'Completed' },
    ],
    taskOutcome: '',
    comment: '',
    isComplete: true,
  },
];

export default actions;
